$(function () {
    $('button[name="postFeedback"]').on('click', send_feedback);

    function send_feedback(e) {
        e.preventDefault();

        var form = $("#feedbackForm ");

        $('textarea[name="message"]', form).attr('disabled', true);
        $('button[name="postFeedback"]').attr('disabled', true);


        $.post("/feedback/send",
            {
                '_token': $('input[name="_token"]', form).val(),
                '_url': $('input[name="_url"]', form).val(),
                'message': $('textarea[name="message"]', form).val(),
                'type': $('input[name="type"]:checked', form).val(),
            },
            function (response) {

                $('textarea[name="message"]', form).val('').attr('disabled', false);
                $('button[name="postFeedback"]').attr('disabled', false);

                if (response.success == false) {
                    systemalert(response.message, 'warning');
                } else {
                    $('#feedbackModal').modal('hide');
                    systemalert(response.message, 'success');
                }

            }.bind(this),
            'json'
        )
            .fail(function () {
                $(this).attr('disabled', false);
                systemalert('There was an system error, please notify an admin!', 'danger');
            })
    }
});